module.exports = __webpack_public_path__ + "video/SAF-500_Ares_SocialEngineering_2025.d9295356.vtt";